import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/error.svg` */
export const ErrorIcon = createTripletGlyphIcon('ErrorIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00037 10.2515C8.33154 10.2516 8.5999 10.5199 8.59998 10.8511C8.59998 11.1823 8.33159 11.4515 8.00037 11.4517C7.669 11.4517 7.39978 11.1824 7.39978 10.8511C7.39986 10.5198 7.66904 10.2515 8.00037 10.2515Z"
        fill="currentColor"
      />
      <path
        d="M7.99939 4.54932C8.30315 4.54932 8.55017 4.79536 8.55017 5.09912V8.99854C8.55017 9.30229 8.30315 9.54932 7.99939 9.54932C7.69586 9.54905 7.44958 9.30213 7.44958 8.99854V5.09912C7.44958 4.79553 7.69586 4.54958 7.99939 4.54932Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34314 1.34229C11.8655 1.52092 14.6664 4.43377 14.6664 8.00049L14.6576 8.34326C14.479 11.8654 11.5669 14.6663 8.00037 14.6665L7.65662 14.6577C4.24801 14.4848 1.51503 11.7519 1.34216 8.34326L1.33337 8.00049C1.33337 4.31866 4.31854 1.3335 8.00037 1.3335L8.34314 1.34229ZM8.00037 2.43311C4.92605 2.43311 2.43298 4.92617 2.43298 8.00049C2.43323 11.0746 4.9262 13.5669 8.00037 13.5669C11.0743 13.5667 13.5665 11.0745 13.5668 8.00049C13.5668 4.92632 11.0745 2.43335 8.00037 2.43311Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 11.5324C9.37269 11.5324 9.67463 11.8346 9.6748 12.2072C9.6748 12.58 9.37279 12.883 9 12.883C8.62721 12.883 8.3252 12.58 8.3252 12.2072C8.32537 11.8346 8.62731 11.5324 9 11.5324Z"
        fill="currentColor"
      />
      <path
        d="M9 5.11737C9.30369 5.11737 9.5497 5.36351 9.5498 5.66718V10.1926C9.5497 10.4962 9.30369 10.7424 9 10.7424C8.69631 10.7424 8.4503 10.4962 8.4502 10.1926V5.66718C8.4503 5.36351 8.69631 5.11737 9 5.11737Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38574 1.50995C13.3485 1.71079 16.5 4.98754 16.5 9.00018L16.4902 9.38593C16.2894 13.3486 13.0126 16.5001 9 16.5002L8.61426 16.4904C4.7792 16.2962 1.70413 13.2209 1.50977 9.38593L1.5 9.00018C1.5 4.85812 4.85794 1.50018 9 1.50018L9.38574 1.50995ZM9 2.59979C5.46545 2.59979 2.59961 5.46564 2.59961 9.00018C2.59968 12.5347 5.4655 15.3996 9 15.3996C12.5344 15.3995 15.3993 12.5346 15.3994 9.00018C15.3994 5.46568 12.5345 2.59987 9 2.59979Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15.3771C12.497 15.3771 12.9002 15.7796 12.9004 16.2766C12.9004 16.7736 12.4971 17.1769 12 17.1769C11.5029 17.1769 11.0996 16.7736 11.0996 16.2766C11.0998 15.7796 11.503 15.3771 12 15.3771Z"
        fill="currentColor"
      />
      <path
        d="M11.999 6.82343C12.4132 6.82343 12.749 7.15921 12.749 7.57343V13.5734C12.7489 13.9875 12.4132 14.3234 11.999 14.3234C11.5849 14.3234 11.2492 13.9875 11.249 13.5734V10.5734V7.57343C11.249 7.15922 11.5848 6.82344 11.999 6.82343Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5146 2.01288C17.7981 2.28082 22 6.6501 22 12.0002L21.9863 12.5148C21.7184 17.7983 17.35 22.0001 12 22.0002L11.4854 21.9865C6.37221 21.7274 2.27199 17.6279 2.0127 12.5148L2 12.0002C2 6.47744 6.47725 2.00018 12 2.00018L12.5146 2.01288ZM12 3.50018C7.30568 3.50018 3.5 7.30586 3.5 12.0002C3.5001 16.6944 7.30574 20.5002 12 20.5002C16.6942 20.5001 20.4999 16.6944 20.5 12.0002C20.5 7.30593 16.6942 3.50028 12 3.50018Z"
        fill="currentColor"
      />
    </svg>
  ),
});
